import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtMXN } from "@/lib/format";

export default function AdminReferrals() {
  const [data, setData] = useState({ rewards: [], leaderboard: [], reward_per_referral: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/referrals").then((r) => {
      setData(r.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="p-8 text-white/50">Cargando...</div>;

  return (
    <div className="p-8" data-testid="admin-referrals">
      <h1 className="font-display text-4xl tracking-wider uppercase text-white mb-2">Referidos</h1>
      <p className="text-white/60 text-sm mb-8">Premio por conversión: {fmtMXN(data.reward_per_referral)}</p>

      <h2 className="font-display text-2xl tracking-wider uppercase text-white mb-4">Top compares</h2>
      <div className="bg-arre-surface border border-arre-border mb-10 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="border-b border-arre-border">
            <tr className="text-left text-[10px] tracking-[0.25em] uppercase text-white/50">
              <th className="p-4">#</th>
              <th className="p-4">Compa</th>
              <th className="p-4">Código</th>
              <th className="p-4">Conversiones</th>
              <th className="p-4">Saldo otorgado</th>
            </tr>
          </thead>
          <tbody>
            {data.leaderboard.map((u, idx) => (
              <tr key={u.email} className="border-b border-arre-border last:border-0 text-white">
                <td className="p-4 text-arre-red font-display text-xl">{idx + 1}</td>
                <td className="p-4">
                  <div>{u.name}</div>
                  <div className="text-xs text-white/40">{u.email}</div>
                </td>
                <td className="p-4 font-mono text-arre-red">{u.referral_code}</td>
                <td className="p-4 font-display text-xl">{u.conversions}</td>
                <td className="p-4 text-arre-red font-bold">{fmtMXN(u.total_credited)}</td>
              </tr>
            ))}
            {data.leaderboard.length === 0 && (
              <tr><td colSpan={5} className="p-10 text-center text-white/40">Aún no hay conversiones.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <h2 className="font-display text-2xl tracking-wider uppercase text-white mb-4">Conversiones recientes</h2>
      <div className="bg-arre-surface border border-arre-border overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="border-b border-arre-border">
            <tr className="text-left text-[10px] tracking-[0.25em] uppercase text-white/50">
              <th className="p-4">Fecha</th>
              <th className="p-4">Referido</th>
              <th className="p-4">Pedido</th>
              <th className="p-4">Saldo</th>
            </tr>
          </thead>
          <tbody>
            {data.rewards.map((r) => (
              <tr key={r.id} className="border-b border-arre-border last:border-0 text-white">
                <td className="p-4 text-xs text-white/50">{new Date(r.created_at).toLocaleString("es-MX")}</td>
                <td className="p-4">{r.referee_email}</td>
                <td className="p-4 font-mono text-xs">{r.order_number}</td>
                <td className="p-4 text-arre-red font-bold">{fmtMXN(r.amount)}</td>
              </tr>
            ))}
            {data.rewards.length === 0 && (
              <tr><td colSpan={4} className="p-10 text-center text-white/40">Sin conversiones aún.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
